import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Action, Store } from '@ngrx/store';
import { first, Observable } from 'rxjs';

import { AppShellAreaService, AppShellAreaType } from '@priva/appshell';
import { PrivaLocalizationService } from '@priva/localization';
import { PrivaNotificationsService } from '@priva/notifications';

import { AuthStore } from 'app/core/stores';
import { AppState } from 'app/state';

import { AppError } from './app.model';
import { ErrorHandlerService } from './core/services/error-handling';

@Component({
    selector: 'gm-root',
    templateUrl: 'app.component.html',
    standalone: false,
})
export class AppComponent implements OnInit {
    AppShellAreaType = AppShellAreaType;

    hasNotificationBar = false;
    hasPrimaryNav = true;

    error$: Observable<AppError | undefined>;

    constructor(
        private store: Store<{ app: AppState }>,
        protected authStore: AuthStore,
        private notificationService: PrivaNotificationsService,
        private appShellAreaService: AppShellAreaService,
        private errorHandler: ErrorHandlerService,
        localization: PrivaLocalizationService,
        private destroyRef: DestroyRef,
    ) {
        this.error$ = this.store.select((s) => s.app.error);
        localization.language.pipe(first()).subscribe();
    }

    ngOnInit() {
        /* TODO: refactor these manual subscribes (use async pipe) */

        // Has notification bar
        this.notificationService.barVisibility
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((visible) => (this.hasNotificationBar = visible));

        // Has primary nav
        this.appShellAreaService
            .hasArea(AppShellAreaType.PrimaryNav)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((available: boolean) => (this.hasPrimaryNav = available));

        // Initialize ErrorHandler
        this.errorHandler.initialize();
    }

    dispatchAction(action: Action) {
        this.store.dispatch(action);
    }
}
